module.exports = __webpack_public_path__ + "static/media/person_female.a47fb72e.png";